import { render, staticRenderFns } from "./m-addSubtopic.vue?vue&type=template&id=6a2810f4&"
import script from "./m-addSubtopic.vue?vue&type=script&lang=js&"
export * from "./m-addSubtopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports